export function TikTokIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      className="h-4 w-4 fill-current"
    >
      <path d="M16.37 3c.24 1.88 1.3 3.52 2.95 4.45.9.51 1.91.8 2.94.83v3.12a8.88 8.88 0 0 1-3.48-.71 9.32 9.32 0 0 1-2.41-1.43v7.18a6.43 6.43 0 1 1-6.43-6.43c.39 0 .77.04 1.14.11v3.2a3.34 3.34 0 1 0 2.2 3.12V3h3.09Z" />
    </svg>
  );
}
